import { Alert, AlertTitle, Typography } from "@mui/material"
import { InstructionType } from "./instructionTypes"
import { makeStyles } from "tss-react/mui"

type InstructionAlertProps = {
    status: InstructionType
    title: string
    text: string
}

const useStyles = makeStyles()(() => ({
    alert: {
        padding: "1rem",
        borderRadius: ".5rem",
    },
}))

export function InstructionAlert({ status, title, text }: InstructionAlertProps) {
    const { classes } = useStyles()

    function getAlertSeverity(status: InstructionType) {
        switch (status) {
            case InstructionType.WARNING:
                return "warning"
            case InstructionType.INFO:
                return "info"
            default:
                return "error"
        }
    }

    return (
        <Alert severity={getAlertSeverity(status)} className={classes.alert}>
            <AlertTitle color={getAlertSeverity(status)}>{title}</AlertTitle>
            <Typography color={getAlertSeverity(status)}>{text}</Typography>
        </Alert>
    )
}
